import { useQuery } from '@tanstack/react-query'

import { basePresenceQueryKey } from '@/ui/services/cache/personaPresence'

export type Presence = {
  connections?: Record<string, boolean>
  lastOnline?: number
}

export function getPresenceQueryKey(personaId: string) {
  const base = [...basePresenceQueryKey]
  return personaId ? [...base, personaId] : base
}

export function usePresenceQuery({ personaId }: { personaId: string }) {
  return useQuery<Presence | null>({
    queryKey: getPresenceQueryKey(personaId),
    queryFn: () => null,
    staleTime: Infinity
  })
}
